import SetupBarTablet from "../SetupBarTablet/SetupBarTablet";

function SetupBar(props) {
  const { currentPageKey } = props;
  return (
    <>
      <div>
        <SetupBarTablet currentPageKey={currentPageKey} />
      </div>
    </>
  );
}

export default SetupBar;
